import { getApiClient } from '../apiClient';
import { SETTINGS_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
  GetSettingsParams,
  GetSettingsResponse,
  CreateSettingPayload,
  CreateSettingResponse,
  UpdateSettingPayload,
  UpdateSettingResponse,
  DeleteSettingResponse,
} from '../types/settings.types';

export const settingsService = {
  getSettings: (params?: GetSettingsParams): Promise<GetSettingsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', String(params.page));
    if (params?.limit) queryParams.append('limit', String(params.limit));
    if (params?.offset) queryParams.append('offset', String(params.offset));
    if (params?.search) queryParams.append('search', params.search);
    if (params?.type !== undefined) queryParams.append('type', String(params.type));

    const url = queryParams.toString()
      ? `${SETTINGS_ENDPOINTS.getSettings}?${queryParams.toString()}`
      : SETTINGS_ENDPOINTS.getSettings;

    return getApiClient().get(url);
  },

  createSetting: (body: CreateSettingPayload): Promise<CreateSettingResponse> => {
    return getApiClient().post(SETTINGS_ENDPOINTS.createSetting, body);
  },

  updateSetting: (id: string, body: UpdateSettingPayload): Promise<UpdateSettingResponse> => {
    const url = replacePathParams(SETTINGS_ENDPOINTS.updateSetting, { id });
    return getApiClient().put(url, body);
  },

  deleteSetting: (id: string): Promise<DeleteSettingResponse> => {
    const url = replacePathParams(SETTINGS_ENDPOINTS.deleteSetting, { id });
    return getApiClient().delete(url);
  },
};


